
import { Component, Ref, Vue } from 'vue-property-decorator';
// eslint-disable-next-line import/no-cycle
import ReCaptchaPlugin from './reCaptchaPlugin';
import type ReCaptchaWidget from './ReCaptchaWidget.vue';

@Component({
	name: 'ReCaptchaWidgetContainer',
	components: { ReCaptchaWidget: () => import('./ReCaptchaWidget.vue') }
})
export default class ReCaptchaWidgetContainer extends Vue {
	@Ref('ReCaptchaWidget') ReCaptchaWidget!: ReCaptchaWidget;

	showReCaptchaModal = false;

	reCaptchaRequested = false;

	reCaptchaMountedPromiseResolve;

	mounted() {
		ReCaptchaPlugin.event.$emit('reCaptchaWidgetContainerReady');
	}

	beforeMount() {
		ReCaptchaPlugin.event.$on('sendWithRecaptchaToken', this.sendWithRecaptchaToken);
		ReCaptchaPlugin.event.$on('initializeRecaptchaWidget', this.initializeRecaptchaWidget);
	}

	beforeDestroy() {
		ReCaptchaPlugin.event.$off('sendWithRecaptchaToken', this.sendWithRecaptchaToken);
		ReCaptchaPlugin.event.$off('initializeRecaptchaWidget', this.initializeRecaptchaWidget);
	}

	async sendWithRecaptchaToken<M extends (data) => any>(
		method: M,
		payload: Omit<Parameters<M>[0], 'recaptchaToken' | 'recaptchaVersion'>,
		action: 'signup' | 'resetPassword' | 'setPassword' | 'verificationCode' | 'complaintForm',
		useRecaptchaV2 = false
	): Promise<void> {
		await this.initializeRecaptchaWidget();

		this.showReCaptchaModal = true;
		const recaptchaResult = await this.ReCaptchaWidget.getRecaptchaToken(action, useRecaptchaV2);

		try {
			if (!(payload instanceof FormData)) {
				payload = {
					...payload,
					...recaptchaResult
				};
			} else {
				payload.set('recaptchaVersion', recaptchaResult.recaptchaVersion);
				payload.set('recaptchaToken', recaptchaResult.recaptchaToken);
			}

			const result = await method(payload);
			this.showReCaptchaModal = false;

			ReCaptchaPlugin.event.$emit('returnRecaptchaMethodCall', result);
		} catch (err: any) {
			if (err.response?.status === 400 && err.response?.data?.code === 'RECAPTCHA_FAILED') {
				await this.sendWithRecaptchaToken(method, payload, action, true);
			} else {
				ReCaptchaPlugin.event.$emit('returnRecaptchaMethodCall', undefined, err);
				this.showReCaptchaModal = false;
			}
		}
	}

	async initializeRecaptchaWidget() {
		this.reCaptchaRequested = true;
		if (this.ReCaptchaWidget) {
			return Promise.resolve();
		}

		return new Promise(resolve => {
			this.reCaptchaMountedPromiseResolve = resolve;
		});
	}

	private async reCaptchaWidgetReady() {
		this.reCaptchaMountedPromiseResolve?.();
		this.reCaptchaMountedPromiseResolve = undefined;
	}
}
